import { EventsRouteName } from '.';
import { AppRouteConfig, breadcrumbs } from '..';
import { Breadcrumb } from '../../types';

export function eventManageApplicationsRoutes(
	routeName: EventsRouteName,
	listBreadcrumb: Breadcrumb | undefined,
): Array<AppRouteConfig> {
	return [
		{
			path: ':id/applications',
			component: {
				render: c => c('router-view'),
			},
			meta: {
				caslSubject: 'events.manage_applications',
				caslAction: 'view',
			},
			children: [
				{
					path: '',
					name: routeName + EventsRouteName.eventApplicationList,
					component: () => import('../../views/event/EventApplicationList.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							listBreadcrumb,
							breadcrumbs.get('eventApplications'),
						],
					},
				},
				{
					path: 'search-contact/:condition',
					name:
						routeName + EventsRouteName.eventApplicationListContactSearchList,
					component: () =>
						import(
							'../../views/event/application/NewEventApplicationContactSearch.vue'
						),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							listBreadcrumb,
							breadcrumbs.get('eventApplications'),
							breadcrumbs.get('addEventApplicationContactSearch'),
						],
						caslSubject: 'events.manage_applications',
						caslAction: 'edit',
					},
				},
				{
					path: 'scan-profile',
					name: routeName + EventsRouteName.eventApplicationListScanProfile,
					component: () =>
						import(
							'../../views/event/application/NewEventApplicationScanProfile.vue'
						),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							listBreadcrumb,
							breadcrumbs.get('eventApplications'),
							breadcrumbs.get('eventApplicationScanProfile'),
						],
						caslSubject: 'events.manage_applications',
						caslAction: 'edit',
					},
				},
				{
					path: 'new',
					name: routeName + EventsRouteName.eventApplicationNewApplication,
					component: () =>
						import('../../views/event/application/NewEventApplication.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							listBreadcrumb,
							breadcrumbs.get('eventApplications'),
							breadcrumbs.get('addEventApplication'),
						],
						caslSubject: 'events.manage_applications',
						caslAction: 'edit',
					},
				},
				{
					path: ':profileId',
					name:
						routeName + EventsRouteName.eventApplicationNewContactApplication,
					component: () => import('../../views/contact/ContactApplication.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							listBreadcrumb,
							breadcrumbs.get('eventApplications'),
							breadcrumbs.get('contactApplicationDetails'),
						],
						caslSubject: 'contacts.applications',
						caslAction: 'view',
					},
				},
			],
		},
	];
}
